import React, { useCallback, useEffect, useState } from "react";
import DiagnosisTodayUX from "./DiagnosisTodayUX";
import ModalSetKeyboardShortcuts from "react-lib/apps/common/ModalSetKeyboardShortcuts";

const TEMPLATE_CHIEF_COMPLAINT: string = "CC";

const Diagnosis = React.memo((props: any) => {
  const [openModTemplateChiefComplaint, setOpenModTemplateChiefComplaint] = useState<boolean>(false);

  const handleSaveDiagnosis = useCallback(() => {
    props.onEvent({ message: "SaveDiagnosis", params: {} });

  }, [props.onEvent]);

  // template
  const handleSetTemplateChiefComplaintShortcut = (event: any) => {
    props.onEvent({
      message: "handleSetTemplateChiefComplaintShortcut",
      params: { event: event, keyType: TEMPLATE_CHIEF_COMPLAINT },
    });
  };

  const handleOpenModTemplateChiefComplaint = () => {
    setOpenModTemplateChiefComplaint(true);
  };

  const handleCloseModTemplateChiefComplaint = () => {
    setOpenModTemplateChiefComplaint(false);
  };

  const handleSaveTemplateChiefComplaint = (data: any) => {
    props.onEvent({
      message: "SaveKeyboardShortcut",
      params: { data, key_type: TEMPLATE_CHIEF_COMPLAINT },
    });
    handleCloseModTemplateChiefComplaint();
  };

  const handleDeleteTemplateChiefComplaint = (data: any) => {
    props.onEvent({
      message: "DeleteKeyboardShortcut",
      params: { data },
    });
  };

  const handleReMedHistory = async () => {
    props.onEvent({ message: "GetReExaminationEncounter", params: { sub: "medicalHistory" } });
  };

  const handleOnMedicalHistoryChange = (name: string, value: any) => {
    // console.log("handleOnMedicalHistoryChange: ", name, value)
    const medicalHistoryList = {...(props.medicalHistoryList || {}), [name]: value}
    props.setProp("medicalHistoryList",  medicalHistoryList)
  }


  // RECEIVE_RESULT = 16, 'ได้รับผลตรวจ'
  // CHECKED_OUT = 10, 'ออกจากห้องตรวจ'
  // WAIT_PAY = 11, 'รอชำระเงินห้องการเงิน'
  // WAIT_DISPENSE = 12, 'รอรับบริการ'
  // DISCHARGED = 13, 'จำหน่ายผู้ป่วยกลับบ้าน'

  // กด "Checkout" (ปุ่มเขียว) หรือ Approve → den_approve_status = APPROVED; "Checkout Draft" → DRAFT (ยังแก้ได้)
  const lockedAfterApproval = props.encounterInfo?.den_approve_status === "APPROVED";
  const isReadOnly = lockedAfterApproval || props.studentLocked;

  return (
    <>
      <DiagnosisTodayUX
        // readonly
        readOnly={isReadOnly}
        disabledReExam={isReadOnly}
        disabledSave={isReadOnly}
        backgroundColorTextArea={isReadOnly ? { backgroundColor: "#e8e8e8" } : {}}
        // function
        onEvent={props.onEvent}
        setProp={props.setProp}
        onTemplateChiefComplaint={handleOpenModTemplateChiefComplaint}
        onSetTemplateKeyboardShortcut={handleSetTemplateChiefComplaintShortcut}
        handleOnMedicalHistoryChange={handleOnMedicalHistoryChange}
        // data
        chiefcomplaints={props.chiefcomplaints}
        presentillness={props.presentillness}
        clinicalfindings={props.clinicalfindings.filter((item: any) => props.filterClinicalFindingIds.includes(item.id))}
        others={props.others}
        diagnosis={props.diagnosis}
        prognosis={props.prognosis}
        saveDiagnosis={handleSaveDiagnosis}
        summaryPreview={props.summaryPreview}
        encounter={props.encounter}
        encounterIndex={props.encounterIndex}
        medicalHistoryList={props.medicalHistoryList}
        occlusionOptions={[
          { key: "normal", value: "normal", text: "Normal" },
          { key: "class1", value: "class1", text: "Class I" },
          { key: "class2", value: "class2", text: "Class II" },
        ]}
        // callback
        onReExamination={handleReMedHistory}
      />

      <ModalSetKeyboardShortcuts
        open={openModTemplateChiefComplaint}
        keyboardShortcut={props.keyboardShortcut?.filter((item: any) => item.key_type === TEMPLATE_CHIEF_COMPLAINT) || []}
        onClose={handleCloseModTemplateChiefComplaint}
        onCancel={handleCloseModTemplateChiefComplaint}
        onDelete={handleDeleteTemplateChiefComplaint}
        onSave={handleSaveTemplateChiefComplaint}
      />
    </>
  );
});

Diagnosis.displayName = "Diagnosis"
export default Diagnosis